import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "platform-admin"
}
const _hoisted_2 = { class: "content" }

import { onMounted, ref } from 'vue';
import PlatformAdminLayoutMenu from './components/PlatformAdminLayoutMenu.vue';
import { useAxios } from '@/api/axios';
import { AxiosResponse } from 'axios';
import { platformAdmin } from '@/global/states/PlatformAdminState';
import router from '@/router';
import { PlatformAdminModel } from '@/models/PlatformAdminModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformAdminLayout',
  setup(__props) {

const isReady = ref<boolean>(false)
const axios = useAxios()

onMounted(() => {
  axios.get('/api/platform-admin/me').then((response: AxiosResponse<PlatformAdminModel>) => {
    platformAdmin.value = response.data
    isReady.value = true
  }).catch(() => {
    router.push({ name: 'platform-admin.login' })
  })
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (isReady.value)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(PlatformAdminLayoutMenu),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_RouterView)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})